import type { IEventBus } from "@/domains/events"
import type { IGaugeRepository } from "@/domains/gauge"
import type { ILockLookup } from "@/domains/lock/interfaces"
import type { ISelectedVotePowerProvider } from "@/domains/selected-power"

import { StrategyManagerOrchestrator } from "./strategy-manager-orchestrator"
import { StrategyManagerStore } from "./strategy-manager-store"

export type StrategyManagerNamespace = {
  Store: StrategyManagerStore
  Orchestrator: StrategyManagerOrchestrator
}

export type StrategyManagerNamespaceFactoryParams = {
  gaugeRepository: IGaugeRepository
  selectedVotePowerProvider: ISelectedVotePowerProvider
  lockLookup: ILockLookup
  eventBus: IEventBus
}

export const StrategyManagerNamespaceFactory = {
  create({
    gaugeRepository,
    selectedVotePowerProvider,
    lockLookup,
    eventBus,
  }: StrategyManagerNamespaceFactoryParams): StrategyManagerNamespace {
    const strategyManagerStore = new StrategyManagerStore(gaugeRepository, selectedVotePowerProvider, lockLookup)

    const strategyManagerOrchestrator = new StrategyManagerOrchestrator(strategyManagerStore, eventBus)

    // Initialize orchestrator to subscribe to events
    strategyManagerOrchestrator.initialize()

    return {
      Store: strategyManagerStore,
      Orchestrator: strategyManagerOrchestrator,
    }
  },
}
